interface LogoProps {
  variant: 'dark' | 'light'
  width?: number
  height?: number
  className?: string
}

const LOGO_PATHS = {
  dark: '/logo-dark.svg',
  light: '/logo-light.svg',
} as const

const DEFAULT_SIZES = {
  dark: { width: 82, height: 60 },
  light: { width: 66, height: 48 },
} as const

export function Logo({ variant, width, height, className }: LogoProps) {
  const logoPath = LOGO_PATHS[variant]
  const defaultSize = DEFAULT_SIZES[variant]
  const logoWidth = width ?? defaultSize.width
  const logoHeight = height ?? defaultSize.height

  return (
    <img
      src={logoPath}
      alt="EBIM Logo"
      width={logoWidth}
      height={logoHeight}
      className={className}
    />
  )
}
